import { principles } from "@/data/design-principles";
import { update } from "./update";
import type { PaddingSize } from "../content-section/index.marko";
import s from "./style.module.css";
export interface Input {
    paddingBlock?: (PaddingSize | null)[];
}

<const/{ paddingBlock }=input>
<let/reduceMotion=false>
<const/debug=false>
<const/refs={ scrolling: false }>
<let/activeIndex=0>

<const/handleScroll() {
    const scrollDriver = scrollWrapperRef().firstElementChild;
    if (!(scrollDriver instanceof HTMLElement)) return;

    const scroll = update(scrollDriver, reduceMotion);
    if (scroll.activeIndex !== activeIndex) activeIndex = scroll.activeIndex;
}>

<const/updateSlideIndex(dir = 1) {
    const scrollDriver = scrollWrapperRef().firstElementChild;
    if (!(scrollDriver instanceof HTMLElement)) return;

    const d = dir < 0 ? -1 : 1;
    const itemWidth = scrollDriver.clientWidth;
    const progress = scrollDriver.scrollLeft / itemWidth;

    if (progress > 0.05 && progress < 0.95) return;

    scrollDriver.scrollBy({ left: d * itemWidth, behavior: "smooth" });
}>

<const/scrollTo(left: number, b: ScrollBehavior = "instant") {
    const scrollDriver = scrollWrapperRef().firstElementChild;
    if (!(scrollDriver instanceof HTMLElement)) return;
    scrollDriver.scrollTo({ left, behavior: b });
}>

<content-section
    class=s.container
    paddingBlock=paddingBlock
    paddingInline=false>
    // --------------------------------------------------------
    // CONTROLS
    <carousel-controls
        count=principles.length
        onProgress(e, dir) {
            e.preventDefault();
            updateSlideIndex(dir);
        }/>
    // --------------------------------------------------------
    // COUNTER + SLIDES
    <div/carouselRef class=s.carouselContainer>
        <carousel-counter count=principles.length/>

        <div class=s.stack>
            <div/scrollWrapperRef class=s.stack>
                <carousel-scroll-driver
                    count=principles.length
                    onScroll() {
                        if (!refs.scrolling) refs.scrolling = true;
                        handleScroll();
                    }
                    onScrollEnd() {
                        refs.scrolling = false;
                    }
                    debug=debug/>
            </div>

            <div class=s.text>
                <for|slide, i| of=principles>
                    <div
                        class=s.textItem
                        data-text
                        aria-hidden=`${activeIndex !== i}`>
                        <h2>${slide.title}</h2>
                        <p>${slide.subtitle}</p>
                    </div>
                </for>
            </div>
        </div>
    </div>

    <carousel-image-stack activeIndex=activeIndex/>
</content-section>

<script>
    reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
    ).matches;
</script>
